import { Link } from "react-router-dom";
import { Container } from "../HtmlTags/Container/Container";
import { Paragraph } from "../HtmlTags/Paragraph/Paragraph";
import "./Footer.css";
import { PAGE_STATIC_LINKS, PAGE_INFO_MESSAGES } from "../../../utils/constants";
import { PageStaticLink } from "../../../types";
import ZelpyeLogo from "../ZelpyeLogo/ZelpyeLogo";
import { ZELPYE_LOGO_VARIANT } from "../ZelpyeLogo/ZelpyeLogo.constants";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <Container className="app-footer-content">
        <Container className="app-footer-brand">
          <ZelpyeLogo variant={ZELPYE_LOGO_VARIANT.TEXT} />
          <Paragraph className="app-footer-subtitle">
            {PAGE_INFO_MESSAGES.APP_TAGLINE}
          </Paragraph>
        </Container>
        <Container className="app-footer-links">
          {PAGE_STATIC_LINKS.map((link: PageStaticLink) => (
            <Link to={link.link} key={link.label} className="app-footer-link">
              {link.label}
            </Link>
          ))}
        </Container>
      </Container>
      <Paragraph className="app-footer-copyright">
        © {currentYear} Zelpye. All rights reserved.
      </Paragraph>
    </footer>
  );
};

export default Footer;
